import { type ReactElement, createContext, useContext } from 'react';

import { TLogLevels } from './LoggerContext';

/* ============================================ Main Component ============================================ */
const ConfigContext = createContext<TConfig>({} as TConfig);

export const ConfigContextProvider: TConfigContextProvider = ({ config, children }) => {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfigContext = () => useContext(ConfigContext);

/* ============================================ Exported Types ============================================ */
export type TEndpointAPIConfig = {
  getAllGiftCardsofType: { url: string; header: Record<string, any> };
  addGiftCard: { url: string; header: Record<string, any> };
  updateGiftCard: { url: string; header: Record<string, any> };
  deleteGiftCard: { url: string; header: Record<string, any> };
};

export type TConfig = {
  appName: string;
  appBasePath: string;
  logger: {
    level: TLogLevels;
    endpoint: string;
  };
  msal: {
    clientId: string;
    authorityId: string;
    redirectUri: string;
  };
  endpointAPI: TEndpointAPIConfig;
};

/* ============================================ Local Types ============================================ */
type TConfigContextProvider = (props: { config: TConfig; children: ReactElement }) => ReactElement;
